import React, { useState, useEffect, useRef } from "react";
import { Http } from "../../../../../helpers/axois";
import CodeEditor from "../../../../../helpers/CodeEditor2";
import { useParams, useHistory } from "react-router-dom";
import { AppState } from "../../../../../stateManager/store";
import { useSelector } from "react-redux";
import { useToast, redirectOnError, encodeBase64, decodeBase64, attachCoreTypeDefs, attachTypeDefs } from "../../../../../helpers/commonFunction";
import { Button, Modal } from "../../../../../helpers/commonUi";
import style from './function.module.sass'
import { getFunctions } from "../../forms/create/properties/commonFunctions";
import { ReactComponent as FileIcon } from "../../../../../assets/svg/MarketplaceFunctions/Filedock.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/svg/MarketplaceFunctions/addBtn.svg";
import update from "immutability-helper";
import { Form, Input, Checkbox, Tooltip } from "antd";
import TarsModal from "../../../../../helpers/TarsModal";
import TarsIcon from "../../../../../assets/images/tarsIcon.png"
import SplitPane, { Pane } from "../../../../../plugin/react-split-pane";
import { ReactComponent as JavaScript } from "../../../../../assets/svg/javascript.svg"
import { ReactComponent as TypeScript } from "../../../../../assets/svg/typescript.svg"
import TarsChatBot from "../../forms/create/properties/TarsChatBot";
import ModalFooter from "../../../../../helpers/commonUi/ModalFooter";
import { MARKETPLACE_CORE, MARKETPLACE_CORE_V3 } from "../../../../../constant/common";
import { initializeA8FormsTypeDefs } from "../../../../../helpers/typedefinitions/a8forms";
import { initializeA8FormsV3TypeDefs } from "../../../../../helpers/typedefinitions/a8formsV3";
import { loadPlugins } from "../../../../../helpers/MicroFrontend";
import { components } from "../../../forms/formBuilder/PropertiesPanel/FormBuilder";
import { ReactComponent as Logo } from '../../../../../assets/svg/signIn_logos/uniphore-color.svg'

const CheckBoxGroup = Checkbox.Group
interface IPermissions {
  a8config: [],
  a8flow: [],
  a8func: [],
  a8gen: []
}
interface IFunction {
  name: string;
  marketplaceInstalledVersion: string;
  marketplaceLatestVersion: string;
  marketplaceId: string;
  source: string;
  comSource: string;
  permissions?: IPermissions;
  release_notes?: string
  id?: string;
  // in marketplace function, `com_source` is the
  // field instead of `comSource`
  com_source?: string;
}

const a8configOptions: string[] = ["getConfig"];
const a8flowOptions: string[] = [
  'evaluateDMN',
  'getNextAvailableAgent',
  'dedupe',
  'getUsers',
  'getUserById',
  'getUsersByGroupId',
  'getGroups',
  'getGroupById',
  'getProcessDefinitions',
  'startNewProcessInstance',
  'startNewProcessInstanceByAppId',
  'getLoggedInUser',
  'getSignedURL',
  'generateSequenceId',
  'eventLogger',
  'setDueDateAndFollowUpDate',
  'getGroupsByUserId',
  'sendMail',
  'generateChecksum',
  'getAssignee',
  'sendMessage'
];

const a8genOptions: string[] = [
  "summarise",
  "sentimentAnalysis"
]


export default function Create() {
  const [source, setSource] = useState<string>("");
  const [lang, setLang] = useState<any>();
  const [mode, setMode] = useState<string>();
  const [exposeEndpoint, setExposeEndpoint] = useState<boolean>();
  const params: any = useParams();
  const history: any = useHistory();
  const appId = params.appId;
  const funcId = params.funcId;
  const [functionData, setFunctionData] = useState<IFunction>();
  const [marketplaceFn, setMarketplaceFn] = useState<IFunction>();
  const [resourceLock, setResourceLock] = useState<any>({});
  const [checkoutVisible, setCheckoutVisible] = useState<boolean>(false)
  const [commitVisible, setCommitVisible] = useState<boolean>(false)
  const [functionsdef, setFunctionsdef] = useState<any>();
  const [updateFnModalVisibility, setUpdateFnModalVisibility] = useState<boolean>(false)
  const [saveFnModalVisibility, setSaveFnModalVisibility] = useState<boolean>(false)
  const [permissionVisible, setPermissionVisible] = useState<boolean>(false)
  const [functionPermission, setFuctionPermission] = useState<IPermissions>();
  const [configPermission, setConfigPermission] = useState<string[]>([])
  const [a8flowPermission, setA8flowPermission] = useState<any[]>([])
  const [a8funcOptions, setA8funcOptions] = useState<any[]>([])
  const [a8GenPermission, setA8GenPermission] = useState<any[]>([])
  const [a8funcPermission, setA8funcPermission] = useState<any>("");
  const [functionList, setFunctionList] = useState<any>([]);
  const [error, setError] = useState('')
  const [isCommit, setIsCommit] = useState(false);
  const appversion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId]);
  const orgId = useSelector((state: AppState) => (state.org && state.org.selectedOrg && state.org.selectedOrg.id));
  const currentVersion = appversion && appversion.currentVersion;
  const { ErrorToast, SuccessToast, WarningToast } = useToast();
  const [currentLine, setCurrentLine] = useState(3)
  const [tarsModal, setTarsModal] = useState(false)
  const editorRef: any = useRef(null)
  const [isPluginsLoaded, setIsPluginsLoaded] = useState(false)
  const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
  })
  const isCheckedIn: boolean = resourceLock.userId === loggedInUserId
  const isUpdateAvailable = functionData && functionData.marketplaceId && (functionData.marketplaceInstalledVersion !== functionData.marketplaceLatestVersion)
  const isMarketplaceFunction = functionData && functionData.marketplaceId;

  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const appPermissions: any = useSelector((state: any) => {
    return state.apps.selectedApp.permissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const canEditFunction = currentVersion && (orgPermissions.includes('func.Edit') || appPermissions.includes('func.Edit'))
  const canForceReleaseFunction = orgPermissions.includes('func.ForceReleaseLock') || appPermissions.includes('func.ForceReleaseLock')

  const version = useSelector(
    (state: any) => state.apps.appVersion[params["appId"]]
  );

  // useEffect(() => {
  //   if((typeof resourceLock.userId !== 'undefined') && (!canEditFunction || !isCheckedIn)) {
  //     WarningToast('Editor is in read-only mode. No authorization to edit this function')
  //   }
  // }, [canEditFunction, WarningToast, resourceLock.userId, isCheckedIn])

  const value: string = `async function main(params) {
  // Start of editable area

  // End of editable area
}`;

  const getResourceLockData = async () => {
    const versionId = appversion.versionId;
    const data: any = await Http.get(`/apps/${appId}/functions/${funcId}?versionId=${versionId}`).toPromise()
    if (data.length) {
      return data[0].resourceLock
    }
  }

  const getFunction = React.useCallback((discard?: boolean) => {
    if (appversion && appversion.versionId) {
      const versionId = appversion.versionId;
      const navigateTo = `/apps/list/${appId}/functions/list`
      Http.get(`/apps/${appId}/functions/${funcId}?versionId=${versionId}`).subscribe((res: any) => {
        if (res.length) {
          if (res[0].permissions) {
            setFuctionPermission(res[0].permissions);
          } else {
            setFuctionPermission({ a8config: [], a8flow: [], a8func: [], a8gen: [] });
          }
          setMode(res[0].mode);
          setLang(res[0].lang);
          setFunctionData(res[0]);
          setResourceLock(res[0].resourceLock || {})
          setExposeEndpoint(res[0].exposeEndpoint)
          if (res[0]?.source) {
            const values = res[0].source;
            const isBase64 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/.test(values);
            const decoded = isBase64 && !values.includes("async") ? decodeBase64(values) : values;
          
            setSource(decoded);
            if (editorRef.current && discard) {
              editorRef.current.setValue(decoded);
            }
          } else {
            setSource(value);
            if (editorRef.current && discard) {
              editorRef.current.setValue(value);
            }
          }
        } else {
          redirectOnError(history, 'no data', navigateTo, "View all functions", "functionId");
        }
      }, (err) => {
        redirectOnError(history, err.message, navigateTo, "View all functions", "functionId");
      })
    }
  }, [appId, funcId, appversion, value, history])

  useEffect(() => {
    getFunction()
  }, [getFunction]);

  useEffect(() => {
    setIsPluginsLoaded(false)
    if (mode === "client") {
      fetchPlugins()
    } else if (mode === "server") {
      setIsPluginsLoaded(true)
    }
  }, [mode])


  function loadCorePlugins() {
    return new Promise(async (res) => {
      await loadPlugins(MARKETPLACE_CORE, "marketplaceCore", () => {
        initializeA8FormsTypeDefs()
        attachCoreTypeDefs();
        res("loaded")
      })
    })
  }

  function loadCoreV3Plugins() {
    return new Promise(async (res) => {
      await loadPlugins(MARKETPLACE_CORE_V3, "marketplaceCore", () => {
        initializeA8FormsV3TypeDefs();
        components.map(item => item.fields).flat().map(el => el.type).forEach(el => attachTypeDefs(el, true, "a8formsV3"))
        res("loaded")
      })
    })
  }

  const fetchPlugins = async () => {
    const resp = await loadCorePlugins();
    if (resp) {
      const res = await loadCoreV3Plugins();
      if (res) {
        setIsPluginsLoaded(true);
      }
    }
  }

  const onEditorSave = (editorValue: { source: string; comSource: string }, discard?: boolean) => {
    const data = {
      source: encodeBase64(editorValue.source),
      comSource: encodeBase64(editorValue.comSource),
      appId,
      versionId: appversion.versionId,
      marketplaceId: null,
      marketplaceInstalledVersion: null,
      marketplaceLatestVersion: null,
      permissions: { ...functionPermission, a8func: a8funcOptions },
    };
    Http.put(`/functions/${funcId}?appId=${appId}&isCommit=${isCommit}${discard ? "&discard=true" : ""}`, data).subscribe(
      () => {
        if (isCommit) {
          SuccessToast('Function Commited successfully')
          getFunction(discard)
          setCommitVisible(false)
        } else {
          SuccessToast('Function saved successfully')
        }
      },
      (err) => {
        ErrorToast(`Error saving function${err.message ? `: ${err.message}` : ""}`)
      }
    );
    setIsCommit(false)
  };

  const onClickCommit = async () => {
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Commit Failed!')
      getFunction()
      setIsCommit(false)
    } else if (lockData.userId === loggedInUserId) {
      setCommitVisible(true)
      setIsCommit(true)
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Commit Failed!`)
      getFunction()
      setIsCommit(false)
    }
  }

  const onRowSelect = (() => {
    setTarsModal(true)
  })

  const onClickCheckout = async () => {
    const lockData: any = await getResourceLockData()
    if (lockData.userId === loggedInUserId) {
      WarningToast('You have already checkout out this resource!')
      getFunction()
    } else {
      setResourceLock(lockData)
      setCheckoutVisible(true)
    }
  }

  const onClickSave = async () => {
    if (isMarketplaceFunction) {
      return setSaveFnModalVisibility(true)
    }
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Save Failed!')
      getFunction()
    } else if (lockData.userId === loggedInUserId) {
      let modalId: number = 7238210;
      let event = new KeyboardEvent("keydown", {
        key: "s",
        code: "KeyS",
        ctrlKey: true,
        detail: modalId,
      });
      document.dispatchEvent(event);
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Save Failed!`)
      getFunction()
    }
  }

  const onConfirmSaveFunction = async () => {
    const lockData: any = await getResourceLockData()
    if (!lockData.userId) {
      ErrorToast('No one has checked out this resource. Save Failed!')
      getFunction()
    } else if (lockData.userId === loggedInUserId) {
      let modalId: number = 7238210;
      let event = new KeyboardEvent("keydown", {
        key: "s",
        code: "KeyS",
        ctrlKey: true,
        detail: modalId,
      });
      document.dispatchEvent(event);
      setSaveFnModalVisibility(false)
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Save Failed!`)
      getFunction()
    }
  }

  const checkout = () => {
    const versionId = appversion.versionId;
    Http.post(`functions/${funcId}/checkout`, {
      appId,
      versionId: versionId
    }).subscribe(() => {
      SuccessToast(`Function checked out`)
      setCheckoutVisible(false)
      getFunction()
    }, (err) => {
      ErrorToast(`Error checking out function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  const commit = () => {

    let modalId: number = 7238210;
    let event = new KeyboardEvent("keydown", {
      key: "s",
      code: "KeyS",
      ctrlKey: true,
      detail: modalId,
    });
    document.dispatchEvent(event);
  }

  const forceRelease = () => {
    Http.post(`functions/${funcId}/force-release`, {
      appId,
      versionId: appversion.versionId
    }).subscribe((res) => {
      SuccessToast(`Function force released successfully`)
      getFunction()
      setCheckoutVisible(false)
    }, (err) => {
      ErrorToast(`Error force releasing function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  useEffect(() => {
    const getFunc = async () => {
      let data = await getFunctions(params["appId"], version.versionId);
      setFunctionsdef(data);
    };
    getFunc()
      .catch(console.error)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePermission = () => {
    setPermissionVisible(!permissionVisible)
  }

  const showUpdateFnModal = async () => {
    if (!functionData) {
      return
    }

    try {
      const marketplaceFn = await fetchMarketplaceFn(functionData.marketplaceId)
      setMarketplaceFn(marketplaceFn)
      setUpdateFnModalVisibility(true)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchMarketplaceFn = async (id: string) => {
    if (!functionData) {
      return
    }
    try {
      const endpoint = `/orgs/${orgId}/marketplaceFunctions/${id}`
      const { data: marketplaceFn }: any = await Http.get(endpoint).toPromise()
      return marketplaceFn
    } catch (err) {
      throw new Error(`failed to get marketplace function`)
    }
  }

  const pullUpdatesFromMarketplaceFn = async () => {
    if (!functionData || !marketplaceFn) {
      return
    }

    const payload = {
      versionId: appversion.versionId,
      functionId: functionData.id,
      marketplaceFunctionVersion: functionData.marketplaceLatestVersion,
    };

    const updateFnEndpoint = `/orgs/${orgId}/apps/${appId}/marketplaceFunctions/${functionData.marketplaceId}`
    Http.put(updateFnEndpoint, payload).subscribe(() => {
      setSource(decodeBase64(marketplaceFn.source))
      setUpdateFnModalVisibility(false)
      setFunctionData((prevState: any) => ({
        ...prevState,
        marketplaceInstalledVersion: functionData.marketplaceLatestVersion,
      }))
      SuccessToast(`Function updated successfully`)
    }, (err) => {
      ErrorToast(`Failed to update function${err.message ? `: ${err.message}` : ""}`)
    })
  }

  const addNewFunc = () => {
    if (!a8funcPermission.trim()) {
      setError("Please enter function name")
      return
    }
    const found = functionList.includes(a8funcPermission)
    if (found) {
      setError("Function already exists")
      return
    }
    setFunctionList((prevState: any) => [...prevState, a8funcPermission])
    setA8funcPermission("")
    setTimeout(() => {
      const node = document.getElementById("functionPermissions");
      if (node) {
        node.scrollTop = node.scrollHeight;
      }
    }, 0);
  }

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter' || event.key === "NumpadEnter") {
      addNewFunc()
    }
  }

  useEffect(() => {
    if (functionPermission && Object.keys(functionPermission).length > 0) {
      const { a8config, a8flow, a8func, a8gen } = functionPermission;
      setFunctionList(a8func);
      setA8funcOptions(a8func);
      setConfigPermission(a8config);
      setA8flowPermission(a8flow);
      setA8GenPermission(a8gen)
    }
  }, [functionPermission])

  const [isVisibleTars, setIsVisibleTars] = useState(true)

  return (
    <div style={{ overflow: "hidden", padding: "0px", height: "100vh" }} className="viewWrapper">
      <SplitPane className={""} paneStyle={{ width: window.innerWidth + "px" }} >
        <Pane className={' override-component-pane'} minSize={!isVisibleTars ? "100%" : "40%"} initialSize={!isVisibleTars ? "100%" : "60%"} maxSize={!isVisibleTars ? "100%" : "80%"}>
          <div
            className="func_header"
            style={{
              fontSize: "16px",
              textTransform: "capitalize",
            }}
          >
            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
              <svg style={{ cursor: "pointer" }} onClick={(() => { history.goBack(); setIsPluginsLoaded(false) })} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 7L1.29289 6.29289L0.585786 7L1.29289 7.70711L2 7ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6V8ZM7.29289 0.292893L1.29289 6.29289L2.70711 7.70711L8.70711 1.70711L7.29289 0.292893ZM1.29289 7.70711L7.29289 13.7071L8.70711 12.2929L2.70711 6.29289L1.29289 7.70711ZM2 8H17V6H2V8Z" fill="#052f35 " />
              </svg>
              <span className="func_name">{(functionData && functionData.name)}</span>
              {
                lang === "javascript" ? <JavaScript></JavaScript> : <TypeScript></TypeScript>
              }
              {
                isUpdateAvailable && (
                  <button className={style.updateBtn} onClick={showUpdateFnModal}>
                    Update
                  </button>
                )
              }
            </div>
            <div
              style={{
                display: "flex",
                height: "30px",
                alignItems: "center"
              }}
            >
              <div className={style.fileIcon} style={{ marginRight: '0px', border: "none", background: "none" }} onClick={handlePermission}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 8.25V18C20 21 18.21 22 16 22H8C5.79 22 4 21 4 18V8.25C4 5 5.79 4.25 8 4.25C8 4.87 8.24997 5.43 8.65997 5.84C9.06997 6.25 9.63 6.5 10.25 6.5H13.75C14.99 6.5 16 5.49 16 4.25C18.21 4.25 20 5 20 8.25Z" stroke="#052f35 " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 4.25C16 5.49 14.99 6.5 13.75 6.5H10.25C9.63 6.5 9.06997 6.25 8.65997 5.84C8.24997 5.43 8 4.87 8 4.25C8 3.01 9.01 2 10.25 2H13.75C14.37 2 14.93 2.25 15.34 2.66C15.75 3.07 16 3.63 16 4.25Z" stroke="#052f35 " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path opacity="0.4" d="M8 13H12" stroke="#052f35 " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path opacity="0.4" d="M8 17H16" stroke="#052f35 " stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              {
                isCheckedIn && canEditFunction && (
                  <>
                    <div style={{ marginLeft: '12px' }}>
                      <button className="func_btn_cmt" onClick={onClickCommit}>
                        COMMIT
                      </button>
                    </div>
                    <div style={{ marginLeft: '12px' }}>
                      <button className="func_btn_sve" onClick={onClickSave}>
                        SAVE
                      </button>
                    </div>
                  </>
                )
              }
              {!isVisibleTars && <Tooltip placement="bottom" title={"A8Gen"} trigger={'hover'}>
                <div className={''} style={{ marginLeft: "12px", display: "flex", alignItems: "center", cursor: "pointer", height: '40px' }} onClick={(() => { setIsVisibleTars(true) })}>
                  <img style={{ height: "33px", width: "33px", objectFit: "contain" }} src={TarsIcon} alt="tars_icon"></img>
                </div>
              </Tooltip>}
              {
                !isCheckedIn && canEditFunction && (
                  <div style={{ marginLeft: '12px' }}>
                    <button className="func_btn_checkout" onClick={onClickCheckout}>CHECKOUT</button>
                  </div>
                )
              }
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ margin: "0", width: permissionVisible ? "calc(100% - 250px)" : "100%" ,height:window.innerHeight-120}}>
              {functionsdef && mode && isPluginsLoaded &&
                <div>
                  <CodeEditor
                    data-test-id="functions_code_editor"
                    minimap={false}
                    value={source || value}
                    height="calc(100vh - 180px)"
                    fontSize={16}
                    type={mode === 'client' ? 'functionClient' : 'functionServer'}
                    lang={lang}
                    onSave={(canEditFunction && isCheckedIn) ? onEditorSave : null}
                    theme="light"
                    readOnly={(!canEditFunction || !isCheckedIn)}
                    customdef={functionsdef}
                    setCurrentLine={setCurrentLine}
                    currentLine={currentLine}
                    editorRef={editorRef}
                  />
                </div>
              }
            </div>
            {permissionVisible && <div id="functionPermissions" className={style.permissionsPanel} style={{ width: "250px" }}>
              <div className={isCheckedIn && canEditFunction ? "permission-checkbox-group" : "permission-checkbox-group-committed"}>
                <div className={style.permissionsHeader} >
                  Permissions
                </div>
                <div className={style.permissionsTitle}>
                  A8Config
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={a8configOptions}
                  value={configPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setConfigPermission(value);
                    setFuctionPermission(update(functionPermission, {
                      a8config: { $set: value }
                    }))
                  }}
                />
                <hr />
                <div className={style.permissionsTitle}>
                  A8Flow
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={a8flowOptions}
                  value={a8flowPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setA8flowPermission(value)
                    setFuctionPermission(update(functionPermission, {
                      a8flow: { $set: value }
                    }))
                  }}
                />
                <hr />
                <div className={style.permissionsTitle}>
                  A8Gen
                </div>
                <CheckBoxGroup
                  style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                  options={a8genOptions}
                  value={a8GenPermission}
                  disabled={isCheckedIn && canEditFunction ? false : true}
                  onChange={(value: any) => {
                    setA8GenPermission(value)
                    setFuctionPermission(update(functionPermission, {
                      a8gen: { $set: value }
                    }))
                  }}
                />
                <br />
                {mode === "client" && <div className={style.permissionsTitle}>
                  A8Func
                </div>}
                {mode === "client" && <div className="functions">
                  {isCheckedIn && canEditFunction ?
                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                      <Form.Item label="Function Name" className={'a8-form-item props col-md-9'}>
                        <Input
                          type="text"
                          value={a8funcPermission}
                          onChange={(e: any) => setA8funcPermission(e.target.value)}
                          onKeyPress={handleKeyPress}
                          placeholder="Enter name"
                        />
                      </Form.Item>
                      <div>
                        <PlusIcon data-test-id="data_plus_icon" width="28px" height="28px" style={{ marginTop: "8px", cursor: 'pointer' }} onClick={addNewFunc} />
                      </div>
                    </div>
                    : null}
                  {error && <p className={style.errMsg}>{error}</p>}
                  <CheckBoxGroup
                    style={{ display: 'flex', flexDirection: 'column', 'width': 'fit-content' }}
                    options={functionList}
                    value={a8funcOptions}
                    disabled={isCheckedIn && canEditFunction ? false : true}
                    onChange={(value: any) => {
                      setA8funcOptions(value)
                    }}
                  />
                </div>}
              </div>
            </div>
            }
          </div>
          <div style={{ width: "100%", height: "70px", display: "flex", alignItems: "center", paddingLeft: "10px", borderTop: "1px solid #D9D9D9" }}>
            <p style={{ paddingRight: 10, marginBottom: 0 }}>Powered By</p>
            <Logo />
            {/* <svg width="98" height="27" viewBox="0 0 98 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M54.3897 23.9439L53.5455 21.7836C53.4373 21.5093 53.3251 21.1736 53.2088 20.7763C53.1253 21.1177 53.021 21.454 52.8964 21.7836L52.0438 23.9439H54.3887H54.3897ZM55.5546 26.8963L54.6523 24.6739H51.7446L50.8526 26.8963H50L52.8655 19.8843H53.5755L56.4279 26.8963H55.5556H55.5546Z" fill="#3461A2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M57.8095 21.6576V25.0529C57.7811 25.3953 57.886 25.7356 58.104 26.008C58.2254 26.1211 58.3707 26.2078 58.5302 26.2622C58.6896 26.3166 58.8594 26.3373 59.0279 26.323C59.2535 26.3423 59.4806 26.3117 59.692 26.2337C59.9033 26.1557 60.0933 26.0323 60.2473 25.8729C60.5435 25.4398 60.6793 24.9237 60.6328 24.4075V21.663H61.4357V26.8964H60.7707L60.6553 26.1943H60.6112C60.4477 26.4511 60.2097 26.6566 59.9265 26.7857C59.6144 26.9268 59.2726 26.9971 58.9276 26.9909C58.6669 27.011 58.4047 26.9816 58.1558 26.9044C57.907 26.8272 57.6765 26.7036 57.4775 26.5408C57.3007 26.3417 57.1671 26.1107 57.0844 25.8614C57.0018 25.6121 56.9718 25.3495 56.9963 25.0889V21.6576H57.8086H57.8095ZM64.5544 26.3383C64.6914 26.3383 64.8282 26.3275 64.9634 26.3059C65.0693 26.2901 65.1742 26.2685 65.2776 26.2411V26.8478C65.1547 26.8991 65.0249 26.9336 64.8921 26.9504C64.741 26.9762 64.5878 26.9898 64.4344 26.9909C63.4082 26.9909 62.8955 26.4574 62.8961 25.3905V22.2778H62.1363V21.8962L62.8998 21.5676L63.2385 20.4497H63.7027V21.6576H65.2448V22.2733H63.7027V25.3536C63.6849 25.6139 63.7659 25.8716 63.9307 26.0791C64.0082 26.1635 64.1045 26.2301 64.2125 26.2738C64.3205 26.3176 64.4373 26.3375 64.5544 26.332V26.3383ZM66.8055 24.2689C66.7682 24.8077 66.9111 25.3438 67.2135 25.7991C67.3621 25.9637 67.5458 26.0956 67.7521 26.186C67.9584 26.2765 68.1826 26.3233 68.4095 26.3233C68.6363 26.3233 68.8605 26.2765 69.0668 26.186C69.2732 26.0956 69.4568 25.9637 69.6054 25.7991C69.9094 25.3444 70.0531 24.808 70.0153 24.2689C70.053 23.7344 69.9092 23.2025 69.6054 22.7531C69.463 22.5792 69.2788 22.4412 69.0685 22.3509C68.8582 22.2606 68.6281 22.2207 68.3982 22.2346C68.1713 22.2205 67.9442 22.2597 67.7366 22.3488C67.5291 22.4379 67.3473 22.5742 67.207 22.7459C66.9067 23.1993 66.7657 23.733 66.8046 24.2689H66.8055ZM70.8463 24.2689C70.891 24.9898 70.6572 25.7013 70.1897 26.2672C69.9638 26.5087 69.6846 26.6987 69.3723 26.8233C69.0601 26.9479 68.7228 27.0039 68.3851 26.9873C67.9399 26.9948 67.5016 26.8806 67.1216 26.6579C66.7469 26.4302 66.4506 26.1014 66.27 25.7127C66.0612 25.2595 65.9588 24.7679 65.9698 24.2725C65.9241 23.5539 66.1555 22.8442 66.6198 22.2787C66.8462 22.0384 67.1258 21.8497 67.4381 21.7267C67.7503 21.6036 68.0874 21.5493 68.4245 21.5676C68.7575 21.5538 69.0895 21.6124 69.3956 21.739C69.7018 21.8655 69.9742 22.0568 70.1925 22.2985C70.6566 22.8592 70.8902 23.5638 70.8491 24.2788L70.8463 24.2689ZM75.8869 26.9009V23.5101C75.9148 23.1674 75.8096 22.8269 75.5915 22.5542C75.4698 22.4415 75.3244 22.355 75.165 22.3007C75.0057 22.2464 74.8361 22.2254 74.6676 22.2391C74.4425 22.2204 74.216 22.2507 74.0049 22.3277C73.7938 22.4047 73.6035 22.5264 73.4482 22.6838C73.1502 23.1162 73.0139 23.6328 73.0618 24.1492V26.8955H72.2579V21.6576H72.9145L73.0458 22.3777H73.0833C73.25 22.1183 73.4905 21.91 73.7765 21.7774C74.0842 21.6346 74.4224 21.5628 74.7642 21.5676C75.024 21.5488 75.2852 21.5796 75.5326 21.658C75.78 21.7365 76.0088 21.8612 76.2058 22.0249C76.3837 22.2248 76.5181 22.4567 76.6012 22.7071C76.6843 22.9575 76.7145 23.2214 76.6898 23.4831V26.8982H75.8869V26.9009ZM78.8781 24.2788C78.8404 24.8175 78.9831 25.3536 79.2852 25.809C79.4338 25.9736 79.6175 26.1055 79.8239 26.196C80.0304 26.2864 80.2546 26.3332 80.4815 26.3332C80.7084 26.3332 80.9327 26.2864 81.1391 26.196C81.3455 26.1055 81.5293 25.9736 81.6779 25.809C81.9816 25.3542 82.1249 24.8178 82.0869 24.2788C82.1244 23.7444 81.981 23.2127 81.6779 22.763C81.5355 22.589 81.3511 22.4509 81.1406 22.3606C80.9301 22.2702 80.6999 22.2304 80.4698 22.2445C80.243 22.2304 80.0161 22.2696 79.8087 22.3587C79.6012 22.4478 79.4196 22.5841 79.2795 22.7558C78.9788 23.209 78.8377 23.7429 78.8771 24.2788H78.8781ZM82.9179 24.2788C82.9622 24.9997 82.7285 25.711 82.2613 26.2771C82.0352 26.5185 81.7557 26.7084 81.4434 26.833C81.131 26.9576 80.7936 27.0137 80.4557 26.9972C80.0105 27.0047 79.5723 26.8905 79.1923 26.6678C78.8176 26.4401 78.5213 26.1113 78.3406 25.7226C78.1322 25.2694 78.0301 24.7777 78.0414 24.2824C77.9959 23.564 78.2269 22.8545 78.6905 22.2886C78.9159 22.0467 79.1949 21.8564 79.5071 21.7316C79.8192 21.6069 80.1565 21.5508 80.4942 21.5676C80.8274 21.5539 81.1595 21.6125 81.4658 21.7391C81.772 21.8656 82.0446 22.0568 82.2632 22.2985C82.7269 22.8594 82.9605 23.5639 82.9198 24.2788H82.9179ZM91.0885 26.9009V23.4903C91.1141 23.1571 91.0187 22.8257 90.8184 22.5524C90.7115 22.4423 90.58 22.3569 90.4338 22.3027C90.2876 22.2484 90.1304 22.2267 89.9742 22.2391C89.7678 22.223 89.5603 22.253 89.3681 22.3269C89.1759 22.4008 89.0042 22.5165 88.8665 22.6649C88.5972 23.0494 88.4712 23.51 88.5091 23.9719V26.8946H87.7053V23.4903C87.7311 23.1569 87.6352 22.8254 87.4342 22.5524C87.3271 22.4426 87.1956 22.3574 87.0494 22.3031C86.9033 22.2489 86.7462 22.227 86.59 22.2391C86.3817 22.2228 86.1723 22.2552 85.9798 22.3336C85.7874 22.412 85.6176 22.534 85.4851 22.6892C85.213 23.1304 85.0904 23.6418 85.1343 24.1528V26.8991H84.3314V21.6576H84.988L85.1193 22.3777H85.1568C85.3077 22.1244 85.5305 21.9174 85.7993 21.781C86.082 21.6372 86.3977 21.5639 86.7176 21.5676C87.0522 21.5286 87.3909 21.5939 87.6838 21.7539C87.9767 21.9139 88.2082 22.1601 88.344 22.4561H88.3815C88.5416 22.181 88.7801 21.9556 89.0691 21.8062C89.3842 21.6436 89.7375 21.5615 90.0952 21.5676C90.3406 21.5494 90.5873 21.5805 90.8194 21.6591C91.0515 21.7377 91.2639 21.862 91.4431 22.024C91.7789 22.4383 91.9387 22.9593 91.8905 23.4822V26.8973L91.0885 26.9009Z" fill="#3461A2" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M95.6001 20.4578C95.2507 20.438 94.9056 20.5399 94.6284 20.7449C94.513 20.8382 94.4214 20.9555 94.3604 21.088C94.2995 21.2204 94.2708 21.3644 94.2766 21.5091C94.2711 21.787 94.3757 22.0566 94.5693 22.2634C94.8795 22.5437 95.2476 22.7584 95.6498 22.8935C96.0286 22.7627 96.3721 22.5524 96.6553 22.2778C96.8492 22.0654 96.9541 21.7915 96.9498 21.5091C96.956 21.3633 96.9268 21.2181 96.8645 21.085C96.8021 20.9519 96.7084 20.8345 96.5906 20.7422C96.3056 20.5391 95.9554 20.4384 95.601 20.4578H95.6001ZM94.044 25.1339C94.0351 25.3036 94.068 25.4728 94.14 25.628C94.212 25.7831 94.3212 25.9198 94.4586 26.0269C94.7965 26.2585 95.2072 26.3716 95.6217 26.3473C96.0346 26.3716 96.4428 26.2531 96.7726 26.0134C96.9091 25.9004 97.017 25.7591 97.0882 25.6002C97.1594 25.4413 97.1919 25.2689 97.1834 25.0961C97.1822 24.9407 97.1472 24.7872 97.0809 24.6454C97.0145 24.5036 96.9181 24.3766 96.7979 24.2725C96.3995 23.9576 95.9411 23.72 95.4481 23.5731C95.0431 23.7201 94.677 23.9512 94.376 24.25C94.1546 24.4951 94.036 24.8105 94.0431 25.1348L94.044 25.1339ZM95.6114 19.8151C96.1733 19.786 96.7286 19.9429 97.1843 20.2597C97.3748 20.4059 97.5265 20.5933 97.6271 20.8065C97.7277 21.0198 97.7743 21.2528 97.763 21.4866C97.7644 21.8269 97.6476 22.1578 97.431 22.4272C97.1436 22.76 96.7803 23.0248 96.3692 23.2014C96.8469 23.3942 97.2749 23.6848 97.6233 24.0529C97.8708 24.3448 98.0036 24.7108 97.9985 25.0871C98.0096 25.349 97.9587 25.61 97.8495 25.8502C97.7404 26.0905 97.5758 26.3039 97.3682 26.4742C96.8778 26.8422 96.2647 27.0265 95.6432 26.9927C95.0081 27.0319 94.3784 26.8589 93.8611 26.503C93.6518 26.3343 93.4864 26.1211 93.378 25.8803C93.2695 25.6395 93.2211 25.3778 93.2364 25.1159C93.2599 24.6931 93.4178 24.2874 93.689 23.9534C93.9602 23.6194 94.3316 23.3733 94.7531 23.2482C94.365 23.0568 94.0288 22.7813 93.7711 22.4434C93.5734 22.157 93.4698 21.8203 93.4737 21.4767C93.4649 21.2453 93.513 21.0152 93.6142 20.805C93.7154 20.5948 93.8668 20.4104 94.0562 20.2669C94.5058 19.9475 95.0574 19.7884 95.616 19.8169" fill="#F1722E" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M88.7454 2.61722C88.632 2.18951 88.4098 1.79546 88.0988 1.4703C87.7878 1.14515 87.3977 0.899031 86.9633 0.753957C85.8378 0.407582 84.6435 0.319105 83.476 0.49562C83.5078 0.449714 83.5135 0.418209 83.535 0.411908C84.8039 0.0818493 86.1196 -0.0512517 87.4323 0.0176527C88.7708 0.132869 89.5399 0.781861 89.2782 1.58657C89.1788 1.85283 89.0629 2.11313 88.9312 2.36609C88.8739 2.45633 88.8093 2.54211 88.7379 2.62262" fill="#F1722E" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M75.8399 6.52741C75.6289 6.50581 75.4788 6.47971 75.3287 6.47521C74.2314 6.44115 73.1357 6.58011 72.0853 6.88656C69.182 7.79449 66.5236 9.30673 64.3001 11.3152C63.7406 11.8421 63.2294 12.4143 62.7722 13.0254C62.4397 13.4176 62.1965 13.8724 62.0584 14.3603C61.8896 14.9904 62.1832 15.3505 62.8763 15.3622C63.0259 15.3661 63.1756 15.358 63.3237 15.3379C64.2113 15.1754 65.0677 14.883 65.8628 14.471C67.4291 13.7003 68.9096 12.7786 70.2815 11.7202C71.031 11.1825 71.7128 10.563 72.3132 9.87409C72.636 9.50144 72.9828 9.14851 73.3515 8.81734C74.1169 8.10444 74.8982 7.40504 75.672 6.70024C75.7142 6.66153 75.7518 6.61653 75.8409 6.52561L75.8399 6.52741ZM71.6744 13.6258C71.3799 13.8499 71.0619 14.0885 70.7458 14.3315C68.9671 15.7356 66.9358 16.8158 64.7522 17.5189C63.8411 17.8479 62.861 17.9621 61.8943 17.8519C61.1242 17.7716 60.391 17.4936 59.7716 17.0472C59.3452 16.7197 59.0199 16.2868 58.8305 15.7952C58.6411 15.3036 58.5949 14.7718 58.6967 14.2568C58.9305 12.8635 59.5772 11.5642 60.5595 10.5141C61.6632 9.29501 62.9612 8.25143 64.4052 7.42214C66.2352 6.25891 68.2513 5.3911 70.3735 4.85318C71.7905 4.47438 73.2806 4.42165 74.7228 4.69925C75.0211 4.76316 75.3137 4.85588 75.6045 4.94859C75.9969 5.07477 76.3274 5.33487 76.5331 5.67949C76.6803 5.60928 76.8285 5.54807 76.9674 5.47156C78.1162 4.82611 79.3612 4.35317 80.6592 4.06916C81.2473 3.94585 81.857 3.90984 82.4563 3.83603C82.5607 3.81935 82.6672 3.81935 82.7715 3.83603C82.5323 3.97195 82.2894 4.10067 82.0549 4.24379C81.1017 4.84408 80.2228 5.54649 79.4351 6.33749C77.7763 7.92137 76.367 9.72894 75.2518 11.7031C74.7733 12.4994 74.4432 13.3697 74.2763 14.2748C74.237 14.5376 74.2389 14.8046 74.282 15.0669C74.3758 15.6349 74.6956 15.8428 75.3137 15.7951C75.8553 15.734 76.3757 15.5575 76.837 15.2785C78.0101 14.6016 79.0814 13.7742 80.0214 12.8193C81.1792 11.6934 82.219 10.4613 83.126 9.14048C83.9588 8.01433 84.5824 6.75845 84.9691 5.42836C85.045 5.11224 85.0821 4.7887 85.0798 4.46432C85.0847 4.23807 85.0146 4.01617 84.8798 3.8305C84.745 3.64484 84.5523 3.50496 84.3294 3.43097C83.7877 3.2183 83.2003 3.13491 82.6177 3.18794C81.1811 3.2779 79.7716 3.60653 78.4522 4.15918C78.3978 4.18078 78.3405 4.19968 78.2327 4.23839C79.7875 2.7231 81.7473 1.64831 83.897 1.13205C84.5508 0.976324 85.2338 0.972621 85.8893 1.12125C86.3918 1.2424 86.847 1.50072 87.1997 1.86495C87.5525 2.22918 87.7877 2.68371 87.8768 3.17354C88.1135 4.22476 88.0539 5.3175 87.7042 6.33929C87.1099 8.29134 86.1469 10.122 84.8632 11.7401C83.7355 13.2469 82.4055 14.6043 80.9078 15.7771C79.5455 16.911 77.9604 17.7717 76.2461 18.3083C75.2891 18.5884 74.2678 18.5944 73.3074 18.3254C72.7802 18.1629 72.3363 17.8154 72.0646 17.3523C71.7105 16.8004 71.5318 16.1613 71.5506 15.5134C71.5609 14.8887 71.6294 14.2658 71.6744 13.6231" fill="#3461A2" />
              <path d="M0 10.1311H2.29594C2.7949 10.102 3.28786 10.2481 3.68271 10.5423C3.84915 10.6833 3.98033 10.8584 4.06646 11.0547C4.1526 11.251 4.19148 11.4635 4.1802 11.6762C4.19052 11.8892 4.15083 12.1016 4.06408 12.2979C3.97732 12.4942 3.84571 12.6692 3.67898 12.8101C3.28667 13.1065 2.79503 13.255 2.29656 13.2278H0.662912V15.655H0V10.1311ZM2.23873 12.6973C2.58184 12.7215 2.92275 12.628 3.20076 12.4335C3.31095 12.3384 3.39728 12.2206 3.45329 12.089C3.50929 11.9573 3.53351 11.8152 3.52413 11.6732C3.53371 11.5319 3.50957 11.3903 3.45353 11.2593C3.39749 11.1283 3.31104 11.0112 3.20076 10.9171C2.92166 10.7251 2.58125 10.633 2.23873 10.6569H0.662912V12.6973H2.23873ZM6.73422 15.7093C6.3801 15.7164 6.03068 15.6305 5.72368 15.461C5.43131 15.2943 5.19645 15.0488 5.04833 14.755C4.88299 14.4213 4.80142 14.055 4.81015 13.6856C4.80064 13.3145 4.88223 12.9466 5.04833 12.6114C5.19629 12.3177 5.43091 12.0722 5.72306 11.9054C6.03006 11.7358 6.37948 11.65 6.73359 11.6571C7.08771 11.65 7.43713 11.7358 7.74413 11.9054C8.03674 12.072 8.27181 12.3175 8.4201 12.6114C8.58621 12.9466 8.6678 13.3145 8.65828 13.6856C8.66721 14.0554 8.58563 14.4221 8.4201 14.7562C8.27211 15.0494 8.03773 15.2944 7.746 15.461C7.43863 15.6307 7.08876 15.7166 6.73422 15.7093ZM6.73422 15.1895C6.90963 15.1996 7.08508 15.1701 7.24651 15.1035C7.40794 15.0368 7.55089 14.9349 7.66391 14.8057C7.90183 14.4783 8.01594 14.0826 7.98728 13.6844C8.013 13.2903 7.89589 12.8998 7.65583 12.5791C7.5448 12.4493 7.40359 12.3462 7.24353 12.2782C7.08347 12.2102 6.90903 12.1792 6.73422 12.1877C6.55817 12.1788 6.3824 12.2096 6.22097 12.2776C6.05954 12.3455 5.91692 12.4488 5.80452 12.5791C5.56418 12.9001 5.44706 13.2911 5.47307 13.6856C5.44435 14.0844 5.56012 14.4806 5.80079 14.8069C5.91489 14.9357 6.05859 15.0373 6.22057 15.1037C6.38256 15.17 6.55839 15.1994 6.73422 15.1895ZM15.8048 11.7526L14.3011 15.655H13.6705L12.5064 12.606L11.3528 15.655H10.7198L9.21609 11.7526H9.90326L11.0512 14.9024L12.2396 11.7526H12.8136L13.9858 14.9102L15.1581 11.7526H15.8048ZM20.0086 13.6856H17.0237C16.9986 14.0898 17.127 14.489 17.385 14.8093C17.5161 14.9407 17.6757 15.0428 17.8524 15.1084C18.0292 15.1741 18.2188 15.2018 18.4079 15.1895C18.8868 15.1882 19.3501 15.0263 19.7176 14.7317L19.9346 15.1895C19.737 15.3609 19.5039 15.4904 19.2506 15.5696C18.9765 15.6622 18.688 15.7094 18.3974 15.7093C18.1234 15.7239 17.8492 15.6837 17.5923 15.5912C17.3354 15.4987 17.1013 15.356 16.9049 15.1722C16.7176 14.9722 16.5734 14.7388 16.4804 14.4852C16.3875 14.2316 16.3476 13.9629 16.3632 13.6945C16.3558 13.328 16.4389 12.965 16.6058 12.6352C16.7568 12.3396 16.9923 12.0912 17.2848 11.9191C17.5849 11.7458 17.9297 11.6571 18.2798 11.6631C18.5175 11.6515 18.7548 11.6911 18.9744 11.779C19.1941 11.8668 19.3904 12.0008 19.5491 12.1709C19.8749 12.5665 20.0384 13.0629 20.0086 13.5662V13.6856ZM18.2867 12.1483C18.135 12.1423 17.9837 12.1652 17.8414 12.2158C17.6991 12.2664 17.5687 12.3437 17.4577 12.4431C17.23 12.669 17.0866 12.9609 17.0498 13.2732H19.4185C19.4101 12.9659 19.2915 12.6708 19.0827 12.4377C18.9783 12.3389 18.8536 12.2621 18.7165 12.2122C18.5795 12.1624 18.433 12.1406 18.2867 12.1483ZM22.8947 11.6595C23.0207 11.6582 23.1463 11.6739 23.2678 11.7061L23.2517 12.2802C23.1133 12.2375 22.9685 12.2173 22.8232 12.2205C22.6584 12.2084 22.4929 12.2341 22.3405 12.2954C22.1881 12.3567 22.053 12.4519 21.9464 12.5732C21.7514 12.8192 21.6502 13.1218 21.6597 13.4308V15.655H21.003V12.8465C21.0061 12.481 20.9853 12.1156 20.9408 11.7526H21.5627L21.6249 12.4741C21.7148 12.2255 21.8883 12.0127 22.118 11.869C22.35 11.7277 22.62 11.6549 22.8947 11.6595ZM27.2522 13.6856H24.2672C24.2415 14.09 24.3694 14.4897 24.6272 14.8105C24.7583 14.9418 24.9178 15.0438 25.0944 15.1095C25.2711 15.1752 25.4606 15.2029 25.6496 15.1907C26.1294 15.1896 26.5937 15.0272 26.9617 14.7317L27.18 15.1895C26.9824 15.3609 26.7493 15.4904 26.496 15.5696C26.222 15.6621 25.9338 15.7093 25.6434 15.7093C25.3689 15.7243 25.0942 15.6843 24.8367 15.5918C24.5792 15.4994 24.3446 15.3564 24.1478 15.1722C23.9598 14.9721 23.8149 14.7384 23.7215 14.4844C23.6281 14.2303 23.5881 13.9611 23.6036 13.6921C23.5962 13.3256 23.6793 12.9626 23.8462 12.6329C23.9972 12.3372 24.2327 12.0888 24.5253 11.9167C24.8253 11.7435 25.1701 11.6547 25.5202 11.6607C25.7579 11.6491 25.9952 11.6887 26.2148 11.7766C26.4345 11.8644 26.6308 11.9984 26.7895 12.1686C27.117 12.5643 27.2816 13.0617 27.2522 13.5662V13.6856ZM25.5314 12.1483C25.3799 12.1423 25.2287 12.1653 25.0865 12.216C24.9443 12.2666 24.814 12.3438 24.7031 12.4431C24.4752 12.6689 24.3315 12.9608 24.2945 13.2732H26.6632C26.6551 12.966 26.5367 12.6709 26.3281 12.4377C26.2237 12.3388 26.0988 12.262 25.9617 12.2121C25.8245 12.1623 25.6779 12.1405 25.5314 12.1483ZM31.8279 9.94495V15.655H31.1811V14.949C31.0681 15.1861 30.8798 15.3829 30.6432 15.5111C30.3874 15.647 30.0985 15.7154 29.8062 15.7093C29.4728 15.7153 29.1451 15.6262 28.8647 15.4532C28.5869 15.2767 28.3668 15.0285 28.2297 14.7371C28.0728 14.4019 27.9955 14.0374 28.0034 13.6701C27.9951 13.3057 28.0712 12.9441 28.226 12.6114C28.3615 12.3227 28.5823 12.0785 28.8609 11.909C29.1449 11.741 29.4732 11.6548 29.8068 11.6607C30.0978 11.6543 30.3853 11.7227 30.6395 11.8588C30.8725 11.9866 31.0588 12.1802 31.173 12.4132V9.94495H31.8279ZM29.9361 15.1895C30.1111 15.1989 30.2858 15.1683 30.4461 15.1002C30.6063 15.0322 30.7474 14.9286 30.8577 14.798C31.0935 14.4725 31.2075 14.08 31.1811 13.6844C31.2066 13.2915 31.0926 12.9019 30.8577 12.5791C30.7474 12.4485 30.6063 12.345 30.4461 12.2769C30.2858 12.2088 30.1111 12.1783 29.9361 12.1877C29.76 12.1791 29.5843 12.2097 29.4225 12.277C29.2607 12.3443 29.1173 12.4464 29.0033 12.5756C28.7609 12.891 28.642 13.2783 28.6675 13.6695C28.6421 14.069 28.7606 14.4647 29.0033 14.7902C29.1154 14.9222 29.2581 15.0272 29.4202 15.0965C29.5822 15.1659 29.7589 15.1977 29.9361 15.1895ZM37.2363 11.6595C37.5698 11.6536 37.8981 11.7398 38.1821 11.9078C38.4613 12.0782 38.6832 12.3226 38.8208 12.6114C38.9782 12.9435 39.0555 13.3053 39.0471 13.6701C39.055 14.0374 38.9777 14.4019 38.8208 14.7371C38.6831 15.0292 38.4616 15.2776 38.1821 15.4532C37.8999 15.626 37.5709 15.715 37.2363 15.7093C36.9448 15.7158 36.6569 15.6461 36.4036 15.5076C36.1666 15.3733 35.9777 15.1731 35.8619 14.9335V15.655H35.2071V9.94495H35.8619V12.4431C35.9717 12.1991 36.16 11.9952 36.3992 11.8612C36.6542 11.7229 36.9434 11.6533 37.2363 11.6595ZM37.115 15.1895C37.2906 15.1975 37.4657 15.1654 37.6259 15.0959C37.7861 15.0264 37.9269 14.9215 38.0366 14.7896C38.2766 14.463 38.3935 14.0677 38.3681 13.6689C38.3934 13.2789 38.2777 12.8925 38.0403 12.575C37.9283 12.4455 37.7863 12.343 37.6256 12.2756C37.4649 12.2083 37.2901 12.178 37.115 12.1871C36.9392 12.177 36.7633 12.2068 36.6018 12.2742C36.4402 12.3416 36.2975 12.4447 36.1853 12.575C35.9492 12.8988 35.8352 13.2901 35.8619 13.6844C35.8356 14.08 35.9496 14.4725 36.1853 14.798C36.2971 14.9289 36.4397 15.0327 36.6012 15.1007C36.7628 15.1687 36.9388 15.1991 37.115 15.1895ZM43.5824 11.7526L41.6826 16.013C41.5297 16.3986 41.2697 16.7367 40.9308 16.9906C40.5963 17.2101 40.2153 17.3559 39.8151 17.4173L39.6777 16.9285C39.9877 16.8745 40.2836 16.7624 40.5483 16.5985C40.7668 16.4329 40.9352 16.2143 41.0359 15.9653L41.1976 15.6162L39.4756 11.7526H40.1628L41.5371 14.9752L42.9276 11.7526H43.5824Z" fill="#9299B4" />
            </svg> */}
          </div>
        </Pane>
        {isVisibleTars &&
          <Pane className={' override-component-pane'} minSize="30%" initialSize="40%" maxSize="60%">
            <TarsChatBot editorRef={editorRef} type={mode === 'client' ? 'clientFn' : 'serverFn'} currentLine={currentLine} setIsVisibleTars={setIsVisibleTars} ></TarsChatBot>
          </Pane>
        }
      </SplitPane>
      <Modal
        id='checkoutModal'
        dataTestId='checkoutModal'
        title={!resourceLock.userId ? "CHECKOUT" : "WARNING"}
        visible={checkoutVisible}
        onCancel={() => {
          setCheckoutVisible(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: true,
          okText: !resourceLock.userId ? "CHECKOUT" : canForceReleaseFunction ? "FORCE RELEASE" : "OK",
          cancelText: "CANCEL",
          onOk: () => {
            if (!resourceLock.userId) {
              checkout()
            } else if (canForceReleaseFunction) {
              forceRelease()
            } else {
              setCheckoutVisible(false)
            }
          }
        }}
      >
        {
          !resourceLock.userId ?
            <>
              <div className={style.modalMsg}>
                Do you want to checkout ?
              </div>
              <div className={style.note}>
                Note: This will prevent others from editing this resource until you commit
              </div>
            </>
            :
            <>
              <div className={style.modalMsg}>
                <span className={style.modalHighlightedMsg}>{resourceLock.userName}</span> has currently checked out this resource
              </div>
              {
                canForceReleaseFunction &&
                <>
                  <div className={style.modalMsg}>
                    Do you want to force release ?
                  </div>
                  <div className={style.note}>
                    Note: This will revoke editing access from the currently checked out user.
                  </div>
                </>
              }
            </>
        }
      </Modal>
      <Modal
        id='commitModal'
        dataTestId='commitModal'
        title="COMMIT"
        visible={commitVisible}
        onCancel={() => {
          setCommitVisible(false)
          setIsCommit(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: false,
        }}
      >
        {
          <>
            <div className={style.modalMsg}>
              Do you want to save or discard your work?
            </div>
            <ModalFooter okText="SAVE & COMMIT" cancelText="DISCARD & COMMIT" okCallback={commit} cancelCallback={() => {onEditorSave({source, comSource: source}, true)}} cancelClassName="discard_btn" />
          </>
        }
      </Modal>
      <Modal
        id="updateFunction"
        unmountOnCancel
        visible={updateFnModalVisibility}
        title="UPDATE FUNCTION"
        onCancel={() => setUpdateFnModalVisibility(false)}
        footer={{
          enable: true,
          okText: 'UPDATE',
          cancelText: 'CANCEL',
          onOk: pullUpdatesFromMarketplaceFn,
        }}
      >
        <div className={style.modalMsg}>
          <p>Are you sure you want to pull updates from marketplace function?</p>
          {marketplaceFn && marketplaceFn.release_notes && (
            <div>
              <p style={{ margin: 0, color: "#3461A2" }}>Release Notes</p>
              <span>{marketplaceFn.release_notes}</span>
            </div>
          )}
        </div>
      </Modal>
      <Modal
        id="saveFunction"
        unmountOnCancel
        visible={saveFnModalVisibility}
        title="SAVE FUNCTION"
        onCancel={() => setSaveFnModalVisibility(false)}
        footer={{
          enable: true,
          okText: 'SAVE',
          cancelText: 'CANCEL',
          onOk: onConfirmSaveFunction,
        }}
      >
        <div className={style.modalMsg}>
          <p>This function will now be treated as A8 function. Are you sure you want to save?</p>
        </div>
      </Modal>
    </div>
  );
};
